import { ColorSwatchPicker } from "../accommodations/primitives";

export function AlertColorPicker({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (color: string) => void;
  label: string;
}) {
  return <ColorSwatchPicker value={value} onChange={onChange} label={label} className="flex-nowrap" />;
}
